/* global App */
var _app;
var FehuForms;

(function () {
    var confirmDialog = function () {
        $("#confirm-dialog").modal("hide");
        $("[data-confirm]").on("click", function (event) {
            $("#confirm-dialog .modal-body").html($(this).data("confirm"));
            $("#dataConfirmOK").attr("href", $(this).attr("href"));
            for (var i = 0; i < this.attributes.length; i++) {
                var attr = this.attributes[i];
                var name = attr.name, value = attr.value;
                if (name !== "data-confirm" && name.indexOf("data") !== -1) {
                    $('#dataConfirmOK').attr(name, value);
                }
            }
            $("#confirm-dialog").modal();
            event.preventDefault();
            event.stopPropagation();
        });
    };
    var datepicker = function () {
        var selector = $(find(".date")).not(".date-disabled");
        selector.each(function () {
            var container = this.parentNode;
            container.classList.add("has-feedback");
            var inputDate = this;
            inputDate.style.cursor = "pointer";
            var picker = document.createElement("ui-date-picker");
            picker.for = inputDate.id;
            container.appendChild(picker);
            var icon = document.createElement("i");
            icon.className = "fa fa-calendar form-control-feedback";
            container.appendChild(icon);
        });
    };
    var tabs = function() {
        $(find(".tabs-trapezoid>.nav")).each(function() {
            var nav = this;
            var selected = nav.querySelector(".active");
            if (selected) nav.scrollLeft = selected.offsetLeft;
        });
    };
    App.Plugins = {
        init: function () {},
        run: function () {
            $("#confirm-dialog").modal("hide");
            confirmDialog();
            datepicker();
            tabs();
            FehuForms.findAndInit();
            this.widget("init");
            if (_app) {
                for (var i in _app) {
                    _app[i]();
                    delete _app[i];
                }
            }
        },
        widget: function (mode, widget) {
            var plugins = this;
            mode = mode || "init";

            if (mode === "init") {
                $('[data-toggle="widget"]').each(function () {
                    if ($(this).data("initialized")) return;
                    $(this).on("click", function (e) {
                        e.preventDefault();
                        var target = $(this).parents(".widget");
                        plugins.widget("toggle", target);
                    });
                    $(this).attr("data-initialized", "true");
                });
                $('[data-show="widget"]').each(function () {
                    if ($(this).data("initialized")) return;
                    $(this).on("click", function (e) {
                        e.preventDefault();
                        var target = $(this).parents(".widget");
                        plugins.widget("show", target);
                    });
                    $(this).attr("data-initialized", "true");
                });
            }

            var widgetBody = $(widget).find('.widget-body');

            if (mode === "toggle") {
                if (widgetBody.hasClass('collapsed')) {
                    widgetBody.removeClass('hidden');
                    widgetBody.removeClass('collapsed');
                    widgetBody.slideDown(200);
                } else {
                    widgetBody.addClass('collapsed');
                    widgetBody.slideUp(200);
                }
            }

            if (mode === "show") {
                if (widgetBody.hasClass('collapsed')) {
                    widgetBody.removeClass('hidden');
                    widgetBody.removeClass('collapsed');
                    widgetBody.slideDown(200);
                }
            }

            if (mode === "hide") {
                if (!widgetBody.hasClass('collapsed')) {
                    widgetBody.addClass('collapsed');
                    widgetBody.slideUp(200);
                }
            }
        }
    };
})();
